/* ============================================================
   KAF PDP Engine — kaf-pdp.js · 2026-07-03
   Gallery (swipe/drag/thumbs/dots) · Lightbox (zoom/pinch)
   Variants · AJAX cart · Sticky ATC · Size guide · Header hide
   Zero dependencies. Loaded with defer from kaf-pdp.liquid.
   ============================================================ */
(function () {
  'use strict';

  var section = document.querySelector('.kaf-pdp');
  if (!section) return;
  var sectionId = section.dataset.sectionId;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ── Data islands ─────────────────────────────────────────── */
  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var variants = readJSON('kaf-variants-' + sectionId) || [];
  var qtyMap = readJSON('kaf-qty-' + sectionId) || {};
  var mediaData = readJSON('kaf-media-' + sectionId) || [];

  var colorOptIdx = parseInt(section.dataset.colorOptionIndex, 10);
  if (isNaN(colorOptIdx)) colorOptIdx = -1;

  /* ============================================================
     GALLERY
     ============================================================ */
  var gallery   = $('.kaf-pdp__gallery', section);
  var stage     = gallery && $('.kaf-pdp__stage', gallery);
  var track     = gallery && $('.kaf-pdp__track', gallery);
  var slides    = gallery ? $$('.kaf-pdp__slide', gallery) : [];
  var thumbs    = gallery ? $$('.kaf-pdp__thumb', gallery) : [];
  var dots      = gallery ? $$('.kaf-pdp__dot', gallery) : [];
  var prevBtn   = gallery && $('.kaf-pdp__nav--prev', gallery);
  var nextBtn   = gallery && $('.kaf-pdp__nav--next', gallery);
  var counterEl = gallery && $('.kaf-pdp__counter-cur', gallery);
  var counterTotalEl = gallery && $('.kaf-pdp__counter-total', gallery);

  var visible = slides.slice();     /* currently visible slides (colour filter) */
  var current = 0;                  /* index within `visible` */

  function slideColor(slide) { return (slide.dataset.color || '').toLowerCase(); }

  function eagerLoadSlide(slide) {
    $$('img[loading="lazy"]', slide).forEach(function (img) { img.loading = 'eager'; });
    var img = $('img', slide);
    if (img && !img.complete && img.decode) img.decode().catch(function () {});
  }

  /* Preload the first slide of every colour after initial load so the
     first colour switch never shows an empty stage. */
  function preloadColourFronts() {
    var seen = {};
    slides.forEach(function (s) {
      var c = slideColor(s);
      if (!c || seen[c]) return;
      seen[c] = true;
      eagerLoadSlide(s);
    });
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(preloadColourFronts, { timeout: 3000 });
  } else {
    setTimeout(preloadColourFronts, 1500);
  }

  function applyColorFilter(colorValue) {
    if (!slides.length) return;
    var want = (colorValue || '').toLowerCase();
    var matches = slides.filter(function (s) { return want && slideColor(s) === want; });
    var nextVisible = matches.length ? matches : slides.slice();
    if (nextVisible.length === visible.length && nextVisible.every(function (s, i) { return s === visible[i]; })) return;
    visible = nextVisible;
    nextVisible.forEach(eagerLoadSlide);
    slides.forEach(function (s) {
      var on = visible.indexOf(s) !== -1;
      s.classList.toggle('is-filtered-out', !on);
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    thumbs.forEach(function (t) {
      var slide = slides[parseInt(t.dataset.index, 10)];
      t.classList.toggle('is-filtered-out', visible.indexOf(slide) === -1);
    });
    dots.forEach(function (d) {
      var slide = slides[parseInt(d.dataset.index, 10)];
      d.classList.toggle('is-filtered-out', visible.indexOf(slide) === -1);
    });
    if (counterTotalEl) counterTotalEl.textContent = visible.length;
    goTo(0, true);
  }

  function setTransform(px, animate) {
    if (!track) return;
    track.style.transition = animate ? 'transform 420ms cubic-bezier(0.32, 0.72, 0, 1)' : 'none';
    track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
  }

  function stageWidth() { return stage ? stage.clientWidth : 0; }

  function goTo(idx, jump) {
    if (!visible.length) return;
    current = Math.max(0, Math.min(idx, visible.length - 1));
    setTransform(-current * stageWidth(), !jump);
    syncUI();
  }

  function syncUI() {
    var activeSlide = visible[current];
    slides.forEach(function (s) { s.classList.toggle('is-active', s === activeSlide); });
    var activeGlobal = slides.indexOf(activeSlide);
    thumbs.forEach(function (t) {
      var on = parseInt(t.dataset.index, 10) === activeGlobal;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      if (on && t.scrollIntoView && !prefersReducedMotion()) {
        try { t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) { /* noop */ }
      }
    });
    dots.forEach(function (d) {
      var on = parseInt(d.dataset.index, 10) === activeGlobal;
      d.classList.toggle('is-active', on);
      d.setAttribute('aria-selected', on ? 'true' : 'false');
      d.setAttribute('tabindex', on ? '0' : '-1');
    });
    if (counterEl) counterEl.textContent = current + 1;
    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current === visible.length - 1;
    if (stage) {
      stage.setAttribute('aria-label', 'Product image ' + (current + 1) + ' of ' + visible.length);
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function switchToMediaId(mediaId) {
    var target = null;
    slides.some(function (s) { if (s.dataset.mediaId == mediaId) { target = s; return true; } return false; });
    if (!target) return;
    if (visible.indexOf(target) === -1) {
      /* media belongs to a filtered-out colour — lift the filter */
      applyColorFilter(null);
    }
    var idx = visible.indexOf(target);
    if (idx >= 0) goTo(idx);
  }

  /* ── Drag / swipe (pointer events → mouse + touch) ────────── */
  (function initDrag() {
    if (!stage || !track || slides.length === 0) return;

    var startX = 0, startY = 0, dx = 0, dragging = false, decided = false, startT = 0, pid = null;

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; decided = false; dx = 0;
      startX = e.clientX; startY = e.clientY; startT = Date.now(); pid = e.pointerId;
      track.style.transition = 'none';
    });

    stage.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pid) return;
      var mx = e.clientX - startX;
      var my = e.clientY - startY;
      if (!decided) {
        if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        /* vertical intent → let the page scroll (touch-action pan-y handles it) */
        if (Math.abs(my) > Math.abs(mx)) { dragging = false; return; }
        decided = true;
        try { stage.setPointerCapture(pid); } catch (err) { /* noop */ }
      }
      dx = mx;
      /* rubber-band at the ends */
      var atStart = current === 0 && dx > 0;
      var atEnd = current === visible.length - 1 && dx < 0;
      var eff = (atStart || atEnd) ? dx * 0.3 : dx;
      setTransform(-current * stageWidth() + eff, false);
      e.preventDefault();
    });

    function endDrag(e) {
      if (!dragging || (pid !== null && e.pointerId !== pid)) return;
      dragging = false; pid = null;
      if (!decided) {
        /* No real movement → treat as a tap/click → lightbox */
        var dt = Date.now() - startT;
        if (dt < 400 && Math.abs(e.clientX - startX) < 6 && Math.abs(e.clientY - startY) < 6) {
          var interactive = e.target.closest && e.target.closest('button, a, video');
          if (!interactive) openLightbox(slides.indexOf(visible[current]));
        }
        setTransform(-current * stageWidth(), false);
        return;
      }
      var w = stageWidth();
      var velocity = dx / Math.max(1, Date.now() - startT); /* px per ms */
      var commit = Math.abs(dx) > w * 0.18 || Math.abs(velocity) > 0.45;
      if (commit && dx < 0) goTo(current + 1);
      else if (commit && dx > 0) goTo(current - 1);
      else goTo(current);
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);

    /* keyboard */
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(slides.indexOf(visible[current])); }
    });

    window.addEventListener('resize', function () { setTransform(-current * stageWidth(), false); }, { passive: true });
  })();

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var slide = slides[parseInt(t.dataset.index, 10)];
      var idx = visible.indexOf(slide);
      if (idx >= 0) goTo(idx);
    });
    t.addEventListener('keydown', function (e) {
      var delta = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0;
      if (!delta) return;
      e.preventDefault();
      goTo(current + delta);
      var active = thumbs.filter(function (x) { return x.classList.contains('is-active'); })[0];
      if (active) active.focus();
    });
  });

  dots.forEach(function (d) {
    d.addEventListener('click', function () {
      var slide = slides[parseInt(d.dataset.index, 10)];
      var idx = visible.indexOf(slide);
      if (idx >= 0) goTo(idx);
    });
  });

  var zoomHint = gallery && $('.kaf-pdp__zoom-hint', gallery);
  if (zoomHint) zoomHint.addEventListener('click', function () { openLightbox(slides.indexOf(visible[current])); });

  /* ============================================================
     LIGHTBOX — native <dialog>, zoom + pinch + pan
     ============================================================ */
  var lightbox = document.getElementById('kaf-lightbox-' + sectionId);
  var lbTrack, lbSlides = [], lbCurrent = 0, lbScale = 1, lbTx = 0, lbTy = 0, lbImg = null;

  function lbVisibleSlides() {
    return lbSlides.filter(function (s) { return !s.classList.contains('is-filtered-out'); });
  }

  function openLightbox(globalIdx) {
    if (!lightbox || typeof lightbox.showModal !== 'function') return;
    lbTrack = $('.kaf-lb__track', lightbox);
    lbSlides = $$('.kaf-lb__slide', lightbox);

    /* mirror the colour filter */
    lbSlides.forEach(function (s, i) {
      var mirror = slides[i] && slides[i].classList.contains('is-filtered-out');
      s.classList.toggle('is-filtered-out', !!mirror);
    });

    /* hydrate large images lazily */
    lbSlides.forEach(function (s) {
      var img = $('img[data-src]', s);
      if (img && !img.src) img.src = img.dataset.src;
    });

    var vis = lbVisibleSlides();
    var target = lbSlides[globalIdx];
    lbCurrent = Math.max(0, vis.indexOf(target));
    lightbox.showModal();
    document.documentElement.classList.add('kaf-lb-open');
    resetZoom();
    lbGoTo(lbCurrent, true);
  }

  function closeLightbox() {
    if (!lightbox) return;
    try { lightbox.close(); } catch (e) { /* noop */ }
  }

  function lbStageWidth() { return lightbox ? lightbox.clientWidth : window.innerWidth; }

  function lbGoTo(idx, jump) {
    var vis = lbVisibleSlides();
    if (!vis.length || !lbTrack) return;
    lbCurrent = Math.max(0, Math.min(idx, vis.length - 1));
    resetZoom();
    lbTrack.style.transition = jump ? 'none' : 'transform 380ms cubic-bezier(0.32, 0.72, 0, 1)';
    lbTrack.style.transform = 'translate3d(' + (-lbCurrent * lbStageWidth()) + 'px, 0, 0)';
    lbSlides.forEach(function (s) { s.classList.remove('is-active'); });
    vis[lbCurrent].classList.add('is-active');
    lbImg = $('.kaf-lb__media', vis[lbCurrent]);
    var count = $('.kaf-lb__count', lightbox);
    if (count) count.textContent = (lbCurrent + 1) + ' / ' + vis.length;
    var pb = $('.kaf-lb__nav--prev', lightbox), nb = $('.kaf-lb__nav--next', lightbox);
    if (pb) pb.disabled = lbCurrent === 0;
    if (nb) nb.disabled = lbCurrent === vis.length - 1;
    /* sync the inline gallery underneath */
    var gIdx = visible.indexOf(slides[lbSlides.indexOf(vis[lbCurrent])]);
    if (gIdx >= 0) goTo(gIdx, true);
  }

  function applyZoom(animate) {
    if (!lbImg) return;
    var maxTx = (lbScale - 1) * lbImg.clientWidth / 2;
    var maxTy = (lbScale - 1) * lbImg.clientHeight / 2;
    lbTx = Math.max(-maxTx, Math.min(maxTx, lbTx));
    lbTy = Math.max(-maxTy, Math.min(maxTy, lbTy));
    lbImg.style.transition = animate ? 'transform 260ms cubic-bezier(0.32, 0.72, 0, 1)' : 'none';
    lbImg.style.transform = 'translate3d(' + lbTx + 'px,' + lbTy + 'px,0) scale(' + lbScale + ')';
    if (lightbox) lightbox.classList.toggle('is-zoomed', lbScale > 1.02);
  }

  function resetZoom() {
    lbScale = 1; lbTx = 0; lbTy = 0;
    if (lbImg) { lbImg.style.transition = 'none'; lbImg.style.transform = ''; }
    if (lightbox) lightbox.classList.remove('is-zoomed');
  }

  if (lightbox) {
    /* close / nav buttons */
    var lbClose = $('.kaf-lb__close', lightbox);
    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    $$('.kaf-lb__nav', lightbox).forEach(function (b) {
      b.addEventListener('click', function () {
        lbGoTo(lbCurrent + (b.classList.contains('kaf-lb__nav--next') ? 1 : -1));
      });
    });
    lightbox.addEventListener('close', function () {
      document.documentElement.classList.remove('kaf-lb-open');
      resetZoom();
      if (stage) stage.focus({ preventScroll: true });
    });
    /* click on the backdrop area closes */
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    lightbox.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); lbGoTo(lbCurrent + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); lbGoTo(lbCurrent - 1); }
    });

    /* wheel zoom (desktop) */
    lightbox.addEventListener('wheel', function (e) {
      if (!lbImg) return;
      e.preventDefault();
      var before = lbScale;
      lbScale = Math.max(1, Math.min(3, lbScale - e.deltaY * 0.0025));
      if (lbScale !== before) applyZoom(false);
      if (lbScale <= 1.02) resetZoom();
    }, { passive: false });

    /* pointer: swipe nav (scale 1) · pan (zoomed) · pinch (2 pointers) · double-tap/click toggles zoom */
    var pointers = {}, pinchStartDist = 0, pinchStartScale = 1, lbStartX = 0, lbStartY = 0, lbDx = 0, lbDragging = false, lbMoved = false, lastTap = 0, panStartTx = 0, panStartTy = 0;

    lightbox.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        pinchStartDist = Math.hypot(a.x - b.x, a.y - b.y);
        pinchStartScale = lbScale;
        lbDragging = false;
      } else if (ids.length === 1) {
        lbStartX = e.clientX; lbStartY = e.clientY; lbDx = 0; lbDragging = true; lbMoved = false;
        panStartTx = lbTx; panStartTy = lbTy;
        if (lbTrack) lbTrack.style.transition = 'none';
      }
    });

    lightbox.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var dist = Math.hypot(a.x - b.x, a.y - b.y);
        if (pinchStartDist > 0) {
          lbScale = Math.max(1, Math.min(3.5, pinchStartScale * (dist / pinchStartDist)));
          applyZoom(false);
        }
        e.preventDefault();
        return;
      }
      if (!lbDragging) return;
      var mx = e.clientX - lbStartX, my = e.clientY - lbStartY;
      if (Math.abs(mx) > 4 || Math.abs(my) > 4) lbMoved = true;
      if (lbScale > 1.02) {
        lbTx = panStartTx + mx; lbTy = panStartTy + my;
        applyZoom(false);
      } else {
        lbDx = mx;
        var vis = lbVisibleSlides();
        var atStart = lbCurrent === 0 && lbDx > 0;
        var atEnd = lbCurrent === vis.length - 1 && lbDx < 0;
        var eff = (atStart || atEnd) ? lbDx * 0.3 : lbDx;
        if (lbTrack) lbTrack.style.transform = 'translate3d(' + (-lbCurrent * lbStageWidth() + eff) + 'px, 0, 0)';
      }
      e.preventDefault();
    });

    function lbEnd(e) {
      delete pointers[e.pointerId];
      if (Object.keys(pointers).length > 0) { pinchStartDist = 0; return; }
      if (!lbDragging) { if (lbScale <= 1.02) resetZoom(); return; }
      lbDragging = false;
      if (lbScale > 1.02) { applyZoom(true); return; }
      if (lbMoved) {
        var w = lbStageWidth();
        if (Math.abs(lbDx) > w * 0.15) lbGoTo(lbCurrent + (lbDx < 0 ? 1 : -1));
        else lbGoTo(lbCurrent);
      } else {
        /* tap: double-tap zoom on touch, single-click zoom on mouse */
        var now = Date.now();
        var isTouch = e.pointerType === 'touch';
        var doubleTap = isTouch && (now - lastTap < 320);
        lastTap = now;
        if (!isTouch || doubleTap) {
          if (lbScale > 1.02) { resetZoom(); applyZoom(true); }
          else if (lbImg) {
            lbScale = 2.4;
            var rect = lbImg.getBoundingClientRect();
            lbTx = (rect.left + rect.width / 2 - e.clientX) * (lbScale - 1);
            lbTy = (rect.top + rect.height / 2 - e.clientY) * (lbScale - 1);
            applyZoom(true);
          }
        }
      }
    }
    lightbox.addEventListener('pointerup', lbEnd);
    lightbox.addEventListener('pointercancel', lbEnd);
    window.addEventListener('resize', function () {
      if (lightbox.open && lbTrack) {
        lbTrack.style.transition = 'none';
        lbTrack.style.transform = 'translate3d(' + (-lbCurrent * lbStageWidth()) + 'px, 0, 0)';
      }
    }, { passive: true });
  }

  /* ============================================================
     VARIANT LOGIC
     ============================================================ */
  var form          = $('form[data-kaf-product-form="' + sectionId + '"]') || $('#kaf-product-form-' + sectionId);
  var variantInput  = document.getElementById('kaf-variant-id-' + sectionId);
  var priceAmountEl = document.getElementById('kaf-price-amount-' + sectionId);
  var availEl       = document.getElementById('kaf-avail-' + sectionId);
  var atcBtn        = document.getElementById('kaf-atc-' + sectionId);
  var atcStatusEl   = document.getElementById('kaf-atc-status-' + sectionId);
  var colorSelectedEl = document.getElementById('kaf-color-selected-' + sectionId);
  var stickyBar     = document.getElementById('kaf-sticky-' + sectionId);
  var stickyBtn     = document.getElementById('kaf-sticky-btn-' + sectionId);
  var stickyVariantEl = document.getElementById('kaf-sticky-variant-' + sectionId);

  var selectedOptions = {};
  $$('.kaf-pdp__swatch.is-active, .kaf-pdp__size.is-active', section).forEach(function (b) {
    selectedOptions[b.dataset.optionIndex] = b.dataset.value;
  });

  function findVariant() {
    return variants.filter(function (v) {
      return Object.keys(selectedOptions).every(function (idx) {
        return v['option' + (parseInt(idx, 10) + 1)] === selectedOptions[idx];
      });
    })[0] || null;
  }

  function formatMoney(cents) {
    var whole = Math.round(cents) / 100;
    var str = (whole % 1 === 0) ? String(whole) : whole.toFixed(2);
    return str + ' JD';
  }

  function applyVariant(variant) {
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;

    /* URL (?variant=) without navigation */
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* noop */ }

    if (priceAmountEl) priceAmountEl.textContent = formatMoney(variant.price);

    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.setAttribute('aria-disabled', String(!variant.available));
      var label = $('.kaf-pdp__atc-label', atcBtn);
      if (label) label.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
    }
    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.childNodes[0].textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
      if (stickyVariantEl) stickyVariantEl.textContent = variant.title !== 'Default Title' ? variant.title : '';
    }
    if (availEl) {
      var qty = qtyMap[String(variant.id)];
      if (typeof qty !== 'number') qty = variant.inventory_quantity; /* fallback */
      if (!variant.available) {
        var vt = (variant.title && variant.title !== 'Default Title')
          ? ' \u2014 ' + String(variant.title).toUpperCase()
          : '';
        availEl.innerHTML = '<span class="kaf-pdp__avail-soldout">'
          + '<svg class="kaf-pdp__avail-x" width="9" height="9" viewBox="0 0 9 9" fill="none" aria-hidden="true">'
          + '<path d="M1 1L8 8M8 1L1 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
          + 'SOLD OUT' + vt + '</span>';
      } else if (typeof qty === 'number' && qty > 0 && qty <= 3) {
        availEl.innerHTML = '<span class="kaf-pdp__avail-low"><span class="kaf-pdp__avail-pulse" aria-hidden="true"></span>ONLY ' + qty + ' LEFT \u2014 SELLING FAST</span>';
      } else {
        availEl.innerHTML = '';
      }
    }
    if (variant.featured_image) switchToMediaId(variant.featured_image.id);
  }

  function refreshSizeAvailability() {
    if (colorOptIdx < 0) return;
    var chosenColor = selectedOptions[colorOptIdx];
    if (!chosenColor) return;
    $$('.kaf-pdp__size', section).forEach(function (btn) {
      var sizeVal = btn.dataset.value;
      var sIdx = parseInt(btn.dataset.optionIndex, 10);
      var avail = variants.some(function (v) {
        return v['option' + (colorOptIdx + 1)] === chosenColor && v['option' + (sIdx + 1)] === sizeVal && v.available;
      });
      btn.classList.toggle('is-sold-out', !avail);
    });
  }

  $$('.kaf-pdp__swatch, .kaf-pdp__size', section).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optIdx = btn.dataset.optionIndex;
      var value = btn.dataset.value;
      selectedOptions[optIdx] = value;

      $$('[data-option-index="' + optIdx + '"]', section).forEach(function (b) {
        var active = b.dataset.value === value;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', String(active));
      });

      if (btn.classList.contains('kaf-pdp__swatch')) {
        if (colorSelectedEl) colorSelectedEl.textContent = value.toUpperCase();
        refreshSizeAvailability();
        applyColorFilter(value);
      }
      applyVariant(findVariant());
    });
  });

  /* ============================================================
     STICKY MOBILE ATC
     ============================================================ */
  if (stickyBar && atcBtn && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting;
      stickyBar.dataset.visible = String(visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
    }, { rootMargin: '0px 0px -20px 0px', threshold: 0 });
    io.observe(atcBtn);
  }
  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  /* ============================================================
     AJAX ADD TO CART → Horizon drawer
     ============================================================ */
  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return false;
    if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
    if (typeof drawer.open === 'function') { drawer.open(); return true; }
    var dlg = drawer.querySelector('dialog');
    if (dlg && typeof dlg.showModal === 'function' && !dlg.open) { dlg.showModal(); return true; }
    return false;
  }

  /* Cart bubble is updated natively by Horizon's cart-icon component,
     which listens for the cart:update event we dispatch below. */

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantInput || !variantInput.value) return;
      if (atcBtn && atcBtn.disabled) return;

      var cartAddUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) ||
        ((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js');

      if (atcBtn) atcBtn.classList.add('is-loading');

      var formData = new FormData(form);
      var sectionIds = $$('cart-items-component[data-section-id]').map(function (el) { return el.dataset.sectionId; }).filter(Boolean);
      if (sectionIds.length) {
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      fetch(cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          if (!r.ok || (r.data && (r.data.status || r.data.errors))) {
            if (atcBtn) atcBtn.classList.remove('is-loading');
            if (atcStatusEl) atcStatusEl.textContent = (r.data && r.data.description) || 'Could not add to bag.';
            form.submit(); /* native fallback so the user is never stuck */
            return;
          }
          if (atcBtn) {
            atcBtn.classList.remove('is-loading');
            atcBtn.classList.add('is-added');
            setTimeout(function () { atcBtn.classList.remove('is-added'); }, 2200);
          }
          return fetch('/cart.js').then(function (res) { return res.json(); }).catch(function () { return null; })
            .then(function (cart) {
              var evt = new Event('cart:update', { bubbles: true });
              evt.detail = {
                resource: cart || undefined,
                sourceId: form.id,
                data: {
                  source: 'product-form-component',
                  itemCount: 1,
                  productId: form.dataset.productId,
                  variantId: variantInput.value,
                  sections: r.data && r.data.sections
                }
              };
              document.dispatchEvent(evt);
              try { openCartDrawer(); } catch (err) { /* noop */ }
              if (atcStatusEl) atcStatusEl.textContent = 'Added to bag.';
            });
        })
        .catch(function () {
          if (atcBtn) atcBtn.classList.remove('is-loading');
          form.submit();
        });
    });
  }

  /* ============================================================
     ACCORDIONS — smooth open / close  (2026-07-26)
     <details> has no native height transition, so the panels used to
     snap open. We animate the body height and stagger its contents.
     Progressive enhancement: the CSS motion is scoped to .is-js, so if
     this never runs the accordions still work natively.
     ============================================================ */
  (function initAccordionMotion() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var DUR = 420;
    $$('.kaf-pdp__accordion', section).forEach(function (det) {
      var hd = $('.kaf-pdp__accordion-hd', det);
      var bd = $('.kaf-pdp__accordion-bd', det);
      if (!hd || !bd) return;
      det.classList.add('is-js');
      if (det.open) det.classList.add('is-open');
      var timer = null;
      hd.addEventListener('click', function (e) {
        e.preventDefault();
        if (timer) return;
        if (det.open) {
          det.classList.remove('is-open');
          bd.style.height = bd.scrollHeight + 'px';
          void bd.offsetHeight;
          bd.style.height = '0px';
          timer = window.setTimeout(function () {
            det.open = false;
            bd.style.height = '';
            timer = null;
          }, DUR);
        } else {
          det.open = true;
          bd.style.height = '0px';
          void bd.offsetHeight;
          bd.style.height = bd.scrollHeight + 'px';
          det.classList.add('is-open');
          timer = window.setTimeout(function () {
            bd.style.height = '';
            timer = null;
          }, DUR);
        }
      });
    });
  })();

  /* ============================================================
     SIZE GUIDE — dialog · cm/in
     ============================================================ */
  (function initSizeGuide() {
    var modal = document.getElementById('kaf-size-modal-' + sectionId);
    if (!modal) return;
    var trigger = $('.kaf-pdp__size-guide-trigger', section);
    var fmsTrigger = $('[data-kaf-fms-open]', section);

    /* ── view switching (FIND MY SIZE / MEASUREMENTS) ── */
    var titleEl = $('[data-kaf-sm-title]', modal);
    function setView(view) {
      $$('[data-kaf-sm-tab]', modal).forEach(function (t) {
        var active = t.dataset.kafSmTab === view;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', String(active));
      });
      $$('[data-kaf-sm-view]', modal).forEach(function (v) {
        v.hidden = v.dataset.kafSmView !== view;
      });
      modal.classList.toggle('is-fit-view', view === 'fit');
      if (titleEl) titleEl.textContent = view === 'fit' ? 'FIND MY SIZE' : 'SIZE GUIDE';
    }
    $$('[data-kaf-sm-tab]', modal).forEach(function (t) {
      t.addEventListener('click', function () { setView(t.dataset.kafSmTab); });
    });

    function openModal(view) {
      if (view) setView(view);
      if (typeof modal.showModal === 'function') modal.showModal();
    }
    if (trigger) trigger.addEventListener('click', function () { openModal('chart'); });
    if (fmsTrigger) fmsTrigger.addEventListener('click', function () { openModal('fit'); });
    var closeBtn = $('.kaf-size-modal__close', modal);
    if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    modal.addEventListener('close', function () { if (trigger) trigger.focus(); });
    setView($$('[data-kaf-sm-view]', modal).length ? 'fit' : 'chart');

    /* ── FIND MY SIZE — recommender ──────────────────────────
       Height/weight → estimated body measure → KAF size.
       Women's tops are calibrated against the real garment specs
       (see GRID below). Men's tops and bottoms are still v1
       estimates awaiting their measurement sheets.             */
    (function initFms() {
      var view = $('[data-kaf-sm-view="fit"]', modal);
      if (!view) return;
      var hIn = $('[data-kaf-fms-height]', view);
      var wIn = $('[data-kaf-fms-weight]', view);
      var goBtn = $('[data-kaf-fms-go]', view);
      var errEl = $('[data-kaf-fms-error]', view);
      var resEl = $('[data-kaf-fms-result]', view);
      var sizeEl = $('[data-kaf-fms-size]', view);
      var noteEl = $('[data-kaf-fms-note]', view);
      var selBtn = $('[data-kaf-fms-select]', view);
      if (!hIn || !wIn || !goBtn || !resEl) return;

      var audience = modal.dataset.audience === 'women' ? 'women' : 'men';
      var chartKey = modal.dataset.chart || '';
      var fitPref = 'true';
      var recommended = null;

      /* sizes actually purchasable on this PDP, in display order */
      function domSizes() {
        var seen = [];
        $$('.kaf-pdp__option--size .kaf-pdp__size', section).forEach(function (b) {
          if (seen.indexOf(b.dataset.value) < 0) seen.push(b.dataset.value);
        });
        return seen;
      }
      function sizeBtn(val) {
        return $$('.kaf-pdp__option--size .kaf-pdp__size', section).filter(function (b) {
          return b.dataset.value === val;
        })[0] || null;
      }

      /* fit preference pills */
      $$('[data-kaf-fms-fit]', view).forEach(function (b) {
        b.addEventListener('click', function () {
          fitPref = b.dataset.kafFmsFit;
          $$('[data-kaf-fms-fit]', view).forEach(function (o) {
            var act = o === b;
            o.classList.toggle('is-active', act);
            o.setAttribute('aria-pressed', String(act));
          });
        });
      });

      /* remember inputs across PDPs (best-effort) */
      try {
        var saved = JSON.parse(localStorage.getItem('kaf-fms') || 'null');
        if (saved) {
          if (saved.h) hIn.value = saved.h;
          if (saved.w) wIn.value = saved.w;
          if (saved.fit) {
            var fb = $('[data-kaf-fms-fit="' + saved.fit + '"]', view);
            if (fb) fb.click();
          }
        }
      } catch (e) { /* noop */ }

      /* Estimated body measure (cm) from height+weight, then a
         continuous size index across band boundaries.
         men  → chest ≈ 0.45w + 0.22h + 27 · bounds S|M|L|XL|XXL
         women→ bust  ≈ 0.52w + 0.18h + 30 · bounds S|M|L|XL

         2026-07-26 — WOMEN'S TOPS ARE NO LONGER GUESSED.
         Their bands are derived from the verified garment specs on the
         QC sheets:   band edge = garment FULL bust − EASE_BUST
         EASE_BUST = 6 cm — KAF's true-to-size allowance on a knit top.
         This is the single tuning knob. Raise it and every woman is
         recommended a larger size; lower it and they drop one. Nothing
         else needs to be touched.

           women-ss  garment full bust  92 · 98 · 104 · 108  → [86, 92, 98]
           women-ls  garment full bust  94 · 100 · 104 · 108 → [88, 94, 98]

         Bottoms are handled separately below — they match on waist now.

         MEN'S TOPS BANDS ARE DELIBERATELY UNCHANGED (2026-07-26).
         The men's tee garment measures 108/112/116/120/124 cm full
         chest. Deriving bands the way the women's tops do
         (garment − EASE_BUST) would put every customer a full size
         down, because this tee is cut with 10–14 cm of ease. That
         ease IS the relaxed drape, not slack to be sized out of, and
         "true to size" means the S you normally wear is our S. The
         bands below already match conventional men's chest sizing,
         so they stay. Do not "fix" them to match the garment.      */
      function menEst(h, w)   { return 0.45 * w + 0.22 * h + 27; }
      function womenEst(h, w) { return 0.52 * w + 0.18 * h + 30; }

      /* ── BOTTOMS · waist-matched, 2026-07-26 ─────────────────
         Bottoms used to be scored off chest/bust, which is a torso
         guess for a pair of trousers. They now match on WAIST.

           body waist  ≈ estimated chest/bust − TORSO_DROP
           band edge   =  garment FULL waist  + WAIST_GIVE

         TORSO_DROP  men 14 · women 18 — the usual chest-to-waist
                     drop; the height/weight estimator only predicts
                     the chest, so this converts it.
         WAIST_GIVE  8 cm — how much more body than garment the
                     elasticated parachute waistband takes without
                     complaint. THIS IS THE KNOB. Lower it and people
                     get pushed up a size; raise it and they drop one.

         Garment FULL waists (half spec × 2), from the QC sheets:
           men-pants / men-shorts  72 · 76 · 80 · 84 · 88
           women-pants             68 · 74 · 78 · 82            */
      function menWaist(h, w)   { return menEst(h, w) - 14; }
      function womenWaist(h, w) { return womenEst(h, w) - 18; }

      var WOMEN_SIZES = ['S', 'M', 'L', 'XL'];
      var MEN_SIZES   = ['S', 'M', 'L', 'XL', 'XXL'];
      var GRID = {
        men:   { sizes: MEN_SIZES, bounds: [94, 100, 106, 113], span: 6, est: menEst },
        women:      { sizes: WOMEN_SIZES, bounds: [88, 93, 98], span: 5, est: womenEst },
        'women-ss': { sizes: WOMEN_SIZES, bounds: [86, 92, 98], span: 6, est: womenEst },
        'women-ls': { sizes: WOMEN_SIZES, bounds: [88, 94, 98], span: 6, est: womenEst },
        'men-pants':   { sizes: MEN_SIZES,   bounds: [80, 84, 88, 92], span: 4, est: menWaist },
        'men-shorts':  { sizes: MEN_SIZES,   bounds: [80, 84, 88, 92], span: 4, est: menWaist },
        'women-pants': { sizes: WOMEN_SIZES, bounds: [76, 82, 86],     span: 5, est: womenWaist }
      };
      var FIT_SHIFT = { fitted: -0.35, 'true': 0, relaxed: 0.35, loose: 0.85 };

      function contIndex(m, g) {
        /* index k covers band [bounds[k-1], bounds[k]] → k-0.5 … k+0.5 */
        var n = g.sizes.length;
        if (m <= g.bounds[0]) return Math.max(-0.49, (m - (g.bounds[0] - g.span)) / g.span - 0.5);
        var last = g.bounds[g.bounds.length - 1];
        if (m >= last) return Math.min(n - 0.51, n - 1.5 + (m - last) / g.span);
        for (var k = 1; k < g.bounds.length; k++) {
          if (m < g.bounds[k]) {
            return k - 0.5 + (m - g.bounds[k - 1]) / (g.bounds[k] - g.bounds[k - 1]);
          }
        }
        return n - 1;
      }

      function recommend() {
        var h = parseFloat(hIn.value);
        var w = parseFloat(wIn.value);
        if (!h || !w || h < 130 || h > 225 || w < 35 || w > 190) {
          errEl.textContent = 'Add your height (cm) and weight (kg) and we’ll do the rest.';
          errEl.hidden = false;
          resEl.hidden = true;
          return;
        }
        errEl.hidden = true;
        try { localStorage.setItem('kaf-fms', JSON.stringify({ h: h, w: w, fit: fitPref })); } catch (e) { /* noop */ }

        var g = GRID[chartKey] || GRID[audience];
        var idx = contIndex(g.est(h, w), g) + (FIT_SHIFT[fitPref] || 0);
        var listed = domSizes();
        var order = g.sizes.filter(function (s) { return listed.indexOf(s) >= 0; });
        if (!order.length) order = listed.length ? listed : g.sizes;
        /* map grid index onto this product's size list */
        var final = Math.min(Math.max(Math.round(idx), 0), g.sizes.length - 1);
        var pick = g.sizes[final];
        if (order.indexOf(pick) < 0) {
          pick = order[Math.min(Math.max(final, 0), order.length - 1)] || order[order.length - 1];
        }
        var between = Math.abs(idx - Math.round(idx)) >= 0.32;
        var neighbor = idx > Math.round(idx) ? g.sizes[Math.min(final + 1, g.sizes.length - 1)] : g.sizes[Math.max(final - 1, 0)];

        var note;
        if (between && neighbor !== pick && order.indexOf(neighbor) >= 0) {
          note = 'You sit between ' + (idx > final ? pick + ' and ' + neighbor : neighbor + ' and ' + pick) + ' — for the fit you chose, we’d go ' + pick + '.';
        } else if (fitPref === 'fitted') {
          note = pick + ' keeps the line closest to the body.';
        } else if (fitPref === 'loose') {
          note = pick + ' gives you the full relaxed drape.';
        } else if (fitPref === 'relaxed') {
          note = pick + ' adds a touch of ease over the true fit.';
        } else {
          note = 'Cut relaxed, fits true to size — ' + pick + ' is your fit.';
        }

        /* sold-out guard for the currently selected colour */
        var btn = sizeBtn(pick);
        if (btn && btn.classList.contains('is-sold-out')) {
          var alt = null;
          var pi = order.indexOf(pick);
          for (var d = 1; d < order.length && !alt; d++) {
            var up = sizeBtn(order[pi + d]);
            var down = sizeBtn(order[pi - d]);
            if (up && !up.classList.contains('is-sold-out')) alt = order[pi + d];
            else if (down && !down.classList.contains('is-sold-out')) alt = order[pi - d];
          }
          if (alt) {
            note = pick + ' is sold out in this colour — ' + alt + ' is the closest fit still available.';
            pick = alt;
          } else {
            note = pick + ' is your fit, but this colour is sold out — try another colour.';
          }
        }

        recommended = pick;
        sizeEl.textContent = pick;
        noteEl.textContent = note;
        selBtn.textContent = 'SELECT ' + pick;
        resEl.hidden = true;
        void resEl.offsetWidth; /* restart reveal animation */
        resEl.hidden = false;
      }

      goBtn.addEventListener('click', recommend);
      [hIn, wIn].forEach(function (inp) {
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); recommend(); } });
      });

      selBtn.addEventListener('click', function () {
        if (!recommended) return;
        var btn = sizeBtn(recommended);
        if (btn) {
          btn.click();
          btn.classList.remove('kaf-fms-flash');
          void btn.offsetWidth;
          btn.classList.add('kaf-fms-flash');
        }
        modal.close();
        if (btn) btn.focus();
      });
    })();

    /* cm / in toggle */
    var unit = 'cm';
    $$('.kaf-size-modal__unit-btn', modal).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.unit === unit) return;
        unit = btn.dataset.unit;
        $$('.kaf-size-modal__unit-btn', modal).forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        $$('[data-cm]', modal).forEach(function (cell) {
          var parts = cell.dataset.cm.split('-');
          cell.textContent = parts.map(function (p) {
            var n = parseFloat(p);
            return unit === 'in' ? (Math.round(n / 2.54 * 2) / 2) : n;
          }).join('–');
        });
        $$('[data-unit-label]', modal).forEach(function (el) { el.textContent = unit.toUpperCase(); });
      });
    });

  })();

  /* Header hide-on-scroll REMOVED — hamburger + cart must be always
     available in the header (founder request, 2026-07-24). */
  document.documentElement.classList.remove('kaf-header--hidden');

  /* ── Init ─────────────────────────────────────────────────── */
  refreshSizeAvailability();
  if (counterTotalEl) counterTotalEl.textContent = visible.length;
  /* If landing directly on a variant with a colour, filter the gallery to it */
  if (colorOptIdx >= 0 && selectedOptions[colorOptIdx]) {
    var initialColorMatches = slides.some(function (s) { return slideColor(s) === String(selectedOptions[colorOptIdx]).toLowerCase(); });
    if (initialColorMatches) applyColorFilter(selectedOptions[colorOptIdx]);
  }
  syncUI();

  /* ============================================================
     COMPLETE THE SET — inline bundle module
     ============================================================ */
  (function initBundle() {
    var root = document.getElementById('kaf-bx-' + sectionId);
    if (!root) return;
    var data = readJSON('kaf-bx-data-' + sectionId);
    if (!data || !data.companions || !data.companions.length) return;

    var SWATCH = {
      'black': { bg: '#202024', br: '#141417' },
      'beige': { bg: '#E2DED4', br: '#C4BFB5' },
      'white': { bg: '#F5F4EF', br: '#C0BDB8' },
      'olive': { bg: '#6B7055', br: '#5A5E46' }
    };
    var SET_CODE = 'KAF-SET';   /* −5 JD · min 49 */
    var KIT_CODE = 'KAF-KIT';   /* −9 JD · min 85 */
    var SET_SAVE = 500, KIT_SAVE = 900, KIT_MIN = 8500;

    var toggle = $('.kaf-bx__toggle', root);
    var panel = $('.kaf-bx__panel', root);
    var optsWrap = $('[data-kaf-bx-options]', root);
    var summary = $('[data-kaf-bx-summary]', root);
    var linesEl = $('[data-kaf-bx-lines]', root);
    var nowEl = $('[data-kaf-bx-now]', root);
    var wasEl = $('[data-kaf-bx-was]', root);
    var saveEl = $('[data-kaf-bx-save]', root);
    var addBtn = $('[data-kaf-bx-add]', root);
    var hintEl = $('[data-kaf-bx-hint]', root);

    function el(tag, cls, html) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (html !== undefined) e.innerHTML = html;
      return e;
    }
    function esc(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function optIdx(product, name) {
      for (var i = 0; i < product.options.length; i++) {
        if (String(product.options[i]).toLowerCase() === name) return i;
      }
      return -1;
    }
    function optValues(product, name) {
      var idx = optIdx(product, name);
      if (idx < 0) return [];
      var seen = [], out = [];
      product.variants.forEach(function (v) {
        var val = v.options[idx];
        if (seen.indexOf(val) === -1) { seen.push(val); out.push(val); }
      });
      return out;
    }
    function findV(product, color, size) {
      var ci = optIdx(product, 'color'), si = optIdx(product, 'size');
      return product.variants.filter(function (v) {
        return (ci < 0 || v.options[ci] === color) && (si < 0 || v.options[si] === size);
      })[0] || null;
    }
    function colorImg(product, color) {
      var ci = optIdx(product, 'color');
      var v = product.variants.filter(function (x) { return ci < 0 || x.options[ci] === color; })[0];
      return (v && v.img) || product.image || '';
    }

    /* one state entry per companion */
    var state = data.companions.map(function (c) {
      return { on: false, open: false, color: optValues(c, 'color')[0] || null, size: null };
    });

    function anchorVariant() {
      var id = variantInput && parseInt(variantInput.value, 10);
      var v = variants.filter(function (x) { return x.id === id; })[0];
      return v || null;
    }

    function renderOpt(i) {
      var c = data.companions[i];
      var st = state[i];
      var box = el('div', 'kaf-bx__opt' + (st.open ? ' is-selected' : '') + (st.on && st.size ? ' is-done' : ''));
      box.dataset.bxOpt = i;

      var head = el('button', 'kaf-bx__opt-head');
      head.type = 'button';
      var img = el('img', 'kaf-bx__opt-img');
      img.src = st.color ? colorImg(c, st.color) : (c.image || '');
      img.alt = '';
      img.loading = 'lazy';
      img.width = 34; img.height = 44;
      head.appendChild(img);
      var meta = el('div', 'kaf-bx__opt-meta');
      meta.appendChild(el('div', 'kaf-bx__opt-label', esc(c.label)));
      var sub = (st.on && st.size)
        ? esc((st.color || '') + ' · ' + st.size)
        : esc(c.title) + ' · +' + formatMoney(c.price);
      meta.appendChild(el('div', 'kaf-bx__opt-sub', sub));
      head.appendChild(meta);
      head.appendChild(el('span', 'kaf-bx__opt-state' + (st.on && st.size ? ' is-done' : ''),
        st.on && st.size
          ? '<svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 7L5.5 10.5L12 3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : '<svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M7 2V12M2 7H12" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>'));
      head.addEventListener('click', function () {
        if (st.on && st.open) {
          /* deselect entirely */
          st.on = false; st.open = false; st.size = null;
        } else if (st.on && !st.open) {
          st.open = true;
          state.forEach(function (o, j) { if (j !== i) o.open = false; });
        } else {
          st.on = true; st.open = true;
          state.forEach(function (o, j) { if (j !== i) o.open = false; });
        }
        renderAll();
      });
      box.appendChild(head);

      var body = el('div', 'kaf-bx__opt-body');
      if (!st.open) body.hidden = true;

      var colors = optValues(c, 'color');
      if (colors.length) {
        var sw = el('div', 'kaf-bx__swatches');
        sw.setAttribute('role', 'radiogroup');
        sw.setAttribute('aria-label', c.label + ' colour');
        colors.forEach(function (col) {
          var conf = SWATCH[col.toLowerCase()] || { bg: '#909090', br: '#707070' };
          var b = el('button', 'kaf-bx__swatch' + (col === st.color ? ' is-active' : ''));
          b.type = 'button';
          b.style.setProperty('--sw-bg', conf.bg);
          b.style.setProperty('--sw-br', conf.br);
          b.setAttribute('aria-label', c.label + ' colour: ' + col);
          b.addEventListener('click', function () {
            st.color = col;
            if (st.size) {
              var v = findV(c, st.color, st.size);
              if (!v || !v.available) st.size = null;
            }
            renderAll();
          });
          sw.appendChild(b);
        });
        body.appendChild(sw);
      }

      var sizes = optValues(c, 'size');
      if (sizes.length) {
        var sz = el('div', 'kaf-bx__sizes');
        sz.setAttribute('role', 'radiogroup');
        sz.setAttribute('aria-label', c.label + ' size');
        sizes.forEach(function (size) {
          var v = findV(c, st.color, size);
          var avail = !!(v && v.available);
          var b = el('button', 'kaf-bx__size' + (size === st.size ? ' is-active' : '') + (avail ? '' : ' is-sold-out'), esc(size));
          b.type = 'button';
          b.disabled = !avail;
          b.addEventListener('click', function () {
            st.size = size;
            st.open = false;
            renderAll();
          });
          sz.appendChild(b);
        });
        body.appendChild(sz);
      }

      box.appendChild(body);
      return box;
    }

    function chosen() {
      return state.map(function (st, i) {
        if (!st.on || !st.size) return null;
        var v = findV(data.companions[i], st.color, st.size);
        return v && v.available ? { v: v, c: data.companions[i], st: st } : null;
      }).filter(Boolean);
    }

    function renderAll() {
      optsWrap.innerHTML = '';
      data.companions.forEach(function (_, i) { optsWrap.appendChild(renderOpt(i)); });

      var picks = chosen();
      var anchor = anchorVariant();
      var anyOn = state.some(function (st) { return st.on; });
      summary.hidden = !anyOn;
      if (!anyOn) return;

      var anchorPrice = anchor ? anchor.price : data.anchor.price;
      var total = anchorPrice;
      picks.forEach(function (p) { total += p.v.price; });

      var saving = 0;
      if (picks.length >= 2 && total >= KIT_MIN) saving = KIT_SAVE;
      else if (picks.length >= 1) saving = SET_SAVE;

      var lines = '<strong>' + esc(data.anchor.title) + '</strong> — your selection above';
      picks.forEach(function (p) {
        lines += '<br><strong>' + esc(p.c.title) + '</strong> — ' + esc((p.st.color || '') + ' · ' + p.st.size);
      });
      linesEl.innerHTML = lines;

      var pending = state.filter(function (st) { return st.on && !st.size; }).length;
      var ready = picks.length > 0 && pending === 0 && anchor && anchor.available;

      nowEl.textContent = formatMoney(total - saving);
      wasEl.textContent = saving ? formatMoney(total) : '';
      saveEl.textContent = saving ? 'SAVE ' + formatMoney(saving) : '';
      saveEl.style.display = saving ? '' : 'none';

      addBtn.disabled = !ready;
      addBtn.textContent = 'ADD SET TO BAG';
      hintEl.textContent = !anchor || !anchor.available
        ? 'Your selected size above is sold out — pick another.'
        : pending > 0
          ? 'Pick a size for the added piece.'
          : 'Saving applies automatically at checkout.';
    }

    /* keep summary in sync when the anchor colour/size changes above */
    section.addEventListener('click', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.target.closest('.kaf-pdp__size') || e.target.closest('.kaf-pdp__swatch')) {
        setTimeout(renderAll, 0);
      }
    });

    toggle.addEventListener('click', function () {
      var open = root.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      if (open) renderAll();
    });

    addBtn.addEventListener('click', function () {
      var picks = chosen();
      var anchor = anchorVariant();
      if (!picks.length || !anchor) return;

      var total = anchor.price;
      picks.forEach(function (p) { total += p.v.price; });
      var code = (picks.length >= 2 && total >= KIT_MIN) ? KIT_CODE : SET_CODE;

      var qty = {};
      qty[anchor.id] = 1;
      picks.forEach(function (p) { qty[p.v.id] = (qty[p.v.id] || 0) + 1; });
      var items = Object.keys(qty).map(function (id) {
        return { id: parseInt(id, 10), quantity: qty[id], properties: { '_Set': 'PDP Set' } };
      });

      var sectionIds = $$('cart-items-component[data-section-id]').map(function (e) { return e.dataset.sectionId; }).filter(Boolean);

      addBtn.disabled = true;
      addBtn.textContent = 'ADDING\u2026';

      fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' })
        .catch(function () { /* non-critical */ })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: items,
              sections: sectionIds.join(','),
              sections_url: window.location.pathname
            })
          });
        })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (d) { return { ok: res.ok, data: d }; });
        })
        .then(function (r) {
          if (!r.ok || (r.data && (r.data.status || r.data.errors))) {
            addBtn.disabled = false;
            addBtn.textContent = 'COULD NOT ADD \u2014 TRY AGAIN';
            setTimeout(renderAll, 2600);
            return;
          }
          return fetch('/cart.js').then(function (res) { return res.json(); }).catch(function () { return null; })
            .then(function (cart) {
              var evt = new Event('cart:update', { bubbles: true });
              evt.detail = {
                resource: cart || undefined,
                sourceId: 'kaf-bx',
                data: {
                  source: 'product-form-component',
                  itemCount: items.reduce(function (n, it) { return n + it.quantity; }, 0),
                  sections: r.data && r.data.sections
                }
              };
              document.dispatchEvent(evt);
              addBtn.classList.add('is-added');
              addBtn.textContent = 'SET ADDED \u2713';
              hintEl.textContent = 'Saving locked in \u2014 applied at checkout.';
              try { openCartDrawer(); } catch (e) { /* noop */ }
              setTimeout(function () {
                addBtn.classList.remove('is-added');
                renderAll();
              }, 3000);
            });
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'COULD NOT ADD \u2014 TRY AGAIN';
          setTimeout(renderAll, 2600);
        });
    });
  })();

})();


